import styled from "styled-components";
import queryString from "query-string";

import { LeadingTitle, FooterSection } from "@components";
import { ObligationAPI, ShortDescriptionAPI } from "@api";
import { useEffect, useState } from "react";
import moment from "moment";
import "./Obligation.scss";
import { useTranslation } from "react-i18next";
const InvestorContainer = styled.div`
  background-color: #f9f9f9;
  padding-top: 56px;
  overflow: hidden;

  @media screen and (max-width: 767px) {
    padding-top: 0;
  }
`;

const Obligation = function () {  
  const {t} = useTranslation();
  const [shortDesc, setShortDesc] = useState(null);
  useEffect(() => {
    const loadData = async () => {
      const { data } = await ShortDescriptionAPI({ loc: "obligasi" });
      setShortDesc(data.data);
    };

    if (!shortDesc) {
      loadData();
    }
  }, [shortDesc]);
  return (
    <InvestorContainer>
      <LeadingTitle
        title={t("obligasi")}
        subtitle={shortDesc !== null ? shortDesc[0].description : ""}
      />
      <Body />
      <FooterSection currentPage={t("obligasi")} />
    </InvestorContainer>
  );
};

const Body = function () {
  const {t} = useTranslation();
  const [obligation, setObligation] = useState();

  useEffect(() => {
    const loadDividen = async () => {
      const filter = {
        cat: "obligasi",
        orderBy: "desc"
      };
      const { data } = await ObligationAPI(queryString.stringify(filter));
      setObligation(data?.data?.result || []);
    };

    if (!obligation) {
      loadDividen();
    }
  });

  return (
    <div className="obligation-content">
      {!obligation
        ? ""
        : obligation.map((data, i) => {
            return (
              <div className="accordion-box" key={i}>
                <div className="accordion" id={`Triwulan-${i}`}>
                  <div className="accordion-item">
                    <h2
                      className="accordion-header"
                      id={`panelsStayOpen-headingTriwulan-${i}`}
                    >
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#panelsStayOpen-collapseTriwulan-${i}`}
                        aria-expanded="false"
                        aria-controls={`panelsStayOpen-collapseTriwulan-${i}`}
                      >
                        {data.title}
                      </button>
                    </h2>
                    <div
                      id={`panelsStayOpen-collapseTriwulan-${i}`}
                      className="accordion-collapse collapse"
                      aria-labelledby={`panelsStayOpen-headingTriwulan-${i}`}
                    >
                      <div className="accordion-body">
                        <div className="card-link">
                          <div className="card-link-item">
                            <div className="card-link-item-left">
                              <div className="card-link-item-left-box">
                                <h5 className="label">
                                  {t("tanggal_efektif_pencatatan_obligasi")}
                                </h5>
                                <p className="label-date">
                                  {moment(
                                    data.tanggal_pencatatan_saham,
                                    "DD-MM-YYYY hh:mm:ss"
                                  ).format("DD MMMM YYYY")}
                                </p>
                              </div>
                            </div>
                            <div className="card-link-item-right">
                              <div className="card-link-item-right__top">
                                <h5 className="label">{t("realisasi_nominal")}</h5>
                                <p className="label-date">
                                  {data.realisasi_nominal}
                                </p>
                              </div>
                              <div className="card-link-item-right__bottom">
                                <div className="card-link-item-right__bottom-left">
                                  <div className="card-link-item-right__bottom-left-box">
                                    <h5 className="label">{t("kupon")}</h5>
                                    <p className="label-date">{data.kupon}</p>
                                  </div>
                                  <div className="card-link-item-right__bottom-left-box">
                                    <h5 className="label">{t("jangka_waktu")}</h5>
                                    <p className="label-date">
                                      {data.jangka_waktu}
                                    </p>
                                  </div>
                                </div>
                                <div className="card-link-item-right__bottom-right">
                                  <div className="card-link-item-right__bottom-right-box-top">
                                    <h5 className="label">{t("harga_penawaran")}</h5>
                                    <p className="label-date">
                                      {data.harga_penawaran}
                                    </p>
                                  </div>
                                  <div className="card-link-item-right__bottom-right-box-bottom">
                                    <div className="card-link-item-right__bottom-right-box-bottom__box">
                                      <h5 className="label">{t("jatuh_tempo")}</h5>
                                      <p className="label-date">                                      
                                        { data.jatuh_tempo !== null ?
                                          moment(
                                            data.jatuh_tempo,
                                            "DD-MM-YYYY hh:mm:ss"
                                          ).format("DD MMMM YYYY") : "-"
                                        }
                                      </p>
                                    </div>
                                    <div className="card-link-item-right__bottom-right-box-bottom__box">
                                      <h5 className="label">
                                        {t("pembayaran_bunga")}
                                      </h5>
                                      <p className="label-date">
                                        {data.pembayaran_bunga}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="card-link-item bottom-content-reverse">
                            <div className="card-link-item-left">
                              <div className="card-link-item-left-box bottom-content">
                                <h5 className="label">{t("pencatatan")}</h5>
                                <p className="label-date">{data.pencatatan}</p>
                              </div>
                            </div>
                            <div className="card-link-item-right">
                              <div className="card-link-item-right__top">
                                <h5 className="label">{t("peringkat_obligasi")}</h5>
                                <p className="label-date">
                                  {data.peringkat_obligasi}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>              
            );
          })}
    </div>
  );
};

export default Obligation;
